import { ActionButton, Spinner, SpinnerSize } from '@fluentui/react';
import { useEffect, useRef } from 'react';
import { Utils } from '../../../common/views/Utils';
import { ShortCustomerModel } from '../../../customers/models/CustomerModel';
import CustomerPicker from '../../../customers/views/searches/CustomerPicker';
import InvoiceDetailView from '../../../invoices/views/shared/InvoiceDetailView';
import { OrderModel } from '../../models/OrderModel';
import { useOrderVM } from '../../viewmodels/OrderVM';
import NewOrderView from '../shared/NewOrderView';
import OrderDetailView from './OrderDetailView';
import OrderGridView from './OrderGridView';

export default function OrderView() {
    const hasLoaded = useRef(false);
    const vm = useOrderVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getList(true);
    }, [vm]);

    const onDelete = (order: OrderModel) => {
        vm.setShowDeleteConfirmed(true);
        vm.setOrder(order);
    }

    const refreshButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Refresh" }}
                onClick={() => vm.getList(true)}
            >Refresh</ActionButton>
        </>;
    }

    const addButton = () => {
        return <>
            <ActionButton
                iconProps={{ iconName: "Add" }}
                onClick={() => vm.setShowAdd(true)}
            >Add New</ActionButton>
        </>;
    }

    const headerView = () => {
        return <div className="ph-15 container">
            <div className="font-title pr-10" style={{ marginBottom: 4 }}>Orders</div>
            {addButton()}
            {refreshButton()}
        </div>;
    }

    const onInvoiceDetail = (id: string) => {
        vm.setSelectedInvoice(id);
        vm.setShowInvoice(true);
    }

    const onInvoiceClose = () => {
        vm.setSelectedInvoice("");
        vm.setShowInvoice(false);
    }

    const mainContent = () => {
        return <div className="ms-Grid">
            <div className="ms-Grid-row center">
                {headerView()}
            </div>

            <div>
                {vm.loading && <Spinner size={SpinnerSize.large} />}

                <OrderGridView
                    orders={vm.orders}
                    key={vm.listHash}
                    onDelete={onDelete}
                    onDetail={(order: OrderModel) => {
                        vm.setShowDetail(true);
                        vm.setOrder(order);
                    }}
                    onInvoiceDetail={onInvoiceDetail}
                />
            </div>
        </div>;
    }

    return <>
        {mainContent()}

        {vm.showAdd && <>
            <NewOrderView isAdmin={false} onClose={() => vm.setShowAdd(false)} />
        </>}

        {vm.showDetail && vm.order !== null && <>
            <OrderDetailView
                order={vm.order}
                onClose={() => vm.setShowDetail(false)}
                onDelete={vm.del}
                onPlaceOrder={vm.placeOrder}
                onInvoiceDetail={onInvoiceDetail}
            />
        </>}

        {vm.showInvoice && !Utils.isNullOrEmpty(vm.selectedInvoice) && <>
            <InvoiceDetailView
                id={vm.selectedInvoice}
                onClose={onInvoiceClose}
            />
        </>}
    </>;
}